import { Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { ApiConstants } from '../../constants/common/api-constant';
import { BehaviorSubject, Subject } from 'rxjs';
import { IUser } from '../../constants/interface/profile';
import { Router } from '@angular/router';
import { AuthService } from './auth-service';
import { ActionConstants } from '../../constants/common/action-contant';
import { MessageService } from 'primeng/api';
import { IServerError } from '../../constants/interface/common';
import { ERole } from '../../constants/enum/role';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  profileData = new BehaviorSubject<IUser | null>(null);
  teamListRefresh = new Subject<void>();

  constructor(
    private apiService: ApiService,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService
  ) { }

  getProfileData(redirect?: boolean, returnUrl?: string, action?: string) {
    this.apiService
      .ExecuteGet(this.apiService.baseUrl + ApiConstants.profileData)
      .subscribe({
        next: (response) => {
          let profile = response as IUser;
          this.profileData.next(profile);
          if (redirect) {
            if (!profile.is_account_verified) {
              this.router.navigate(['/verify-email'], {
                queryParams: { email: profile.email, returnUrl, action }
              })
            } else {
              if (action) {
                this.executeAction(action);
              }
              returnUrl ? this.router.navigateByUrl(returnUrl) : this.router.navigate(['/profile']);
            }
          }
        }, error: (error) => {
          this.router.navigate(['/']);
          this.profileData.next(null);
        }
      });
  }

  logOut() {
    this.authService.clearToken();
    this.profileData.next(null);
    this.router.navigate(['/']);
  }

  executeAction(action: string): void {
    const [actionKey, actionId] = action.split(':');
    switch (actionKey) {
      case ActionConstants.requestService:
        this.requestService(actionId);
        break;
    }
  }

  requestService(serviceId: string): void {
    if (!serviceId) return;
    if (this.profileData.value?.current_role?.role !== ERole.EMPLOYER) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Not Allowed',
        detail: 'Please contact your company manager for requesting the service.'
      });
      return;
    }
    this.apiService.ExecutePost(this.apiService.baseUrl + ApiConstants.requestService, { service: serviceId }).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Your service request has been submitted.'
        });
      },
      error: ({ error }: IServerError) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.message || 'Failed to submit service request. Please try again.'
        });
      }
    });
  }

}
